import { SET_PACKAGE_COUNT, ADD_PACKAGE, REMOVE_PACKAGE, UPDATE_PACKAGE, SET_UPLOAD_PROGRESS, RESET_PACKAGE, SET_INITIAL_PACKAGES, SET_REFERENCE_PACKAGES, SET_PACKAGE_DIMENSION_UNIT, RESET_PACKAGE_DIMENSIONS, SET_EDIT_PACKAGE_BTN } from '../../Actions/PackageWeight/actionTypes';
import { cmToFt, ftToCm } from '../../utilities/conversion';
import { normalizeImages } from '../../utilities/packages';

const initialState = {
  packageCount: 1,
  packages: [
    {
      images: Array(4).fill(null),
      productName: "",
      packageLength: "",
      packageWidth: "",
      packageHeight: "",
      actualWeight: "",
      weight: "",
      vWeight: ""
    },
  ],
  initialPackages: [
    {
      images: Array(4).fill(null),
      productName: "",
      packageLength: "",
      packageWidth: "",
      packageHeight: "",
      actualWeight: "",
      weight: "",
      vWeight: ""
    },
  ],
  uploadProgress: [0], // Initialize progress to 0 for the first package
  referencePackages: [],
  isPackageNull: true,
  dimensionUnit: "ft",
  isEditBtnActive:false
};
const packageReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_INITIAL_PACKAGES:
      return {
        packageCount: action.payload.length,
        packages: action.payload.map(pkg => ({
          images: normalizeImages(pkg?.images),
          productName: pkg.productName || "",
          packageLength: pkg.packageLength || "",
          packageWidth: pkg.packageWidth || "",
          packageHeight: pkg.packageHeight || "",
          actualWeight: pkg.actualWeight || "",
          weight: pkg.weight || "",
          vWeight: pkg.vWeight || (pkg.packageHeight * pkg.packageWidth * pkg.packageLength) / 5000 || ""
        })),
        uploadProgress: Array(action.payload.length).fill(0),
        isPackageNull: action.payload.length === 0 ? true : false,
        initialPackages: action.payload.map(pkg => ({
          images: normalizeImages(pkg?.images),
          productName: pkg.productName || "",
          packageLength: pkg.packageLength || "",
          packageWidth: pkg.packageWidth || "",
          packageHeight: pkg.packageHeight || "",
          actualWeight: pkg.actualWeight || "",
          weight: pkg.weight || "",
          vWeight: pkg.vWeight || (pkg.packageHeight * pkg.packageWidth * pkg.packageLength) / 5000 || ""
        })),
        dimensionUnit: action.payload[0]?.dimensionUnit || "ft",
        isEditBtnActive:false
      };

    case SET_PACKAGE_COUNT:
      return { ...state, packageCount: action.payload };

    case ADD_PACKAGE:
      const freshPackages = Array.from({ length: state.packageCount }, () => ({
        images: Array(4).fill(null),
        productName: "",
        packageLength: "",
        packageWidth: "",
        packageHeight: "",
        actualWeight: "",
        weight: "",
        vWeight: ""
      }));

      const freshUploadProgress = Array(state.packageCount).fill(0);

      return {
        ...state,
        packages: [...freshPackages],
        uploadProgress: [...freshUploadProgress],
      };

    case REMOVE_PACKAGE:
      return {
        ...state,
        packages: state.packages.filter((_, index) => index !== action.payload),
        uploadProgress: state.uploadProgress.filter((_, index) => index !== action.payload),
      };

    case UPDATE_PACKAGE:
      return {
        ...state,
        packages: state.packages.map((pkg, index) => {
          if (index === action.payload.index) {
            let pLen, pWid, pHei;
            const updatedPackage = { ...pkg, ...action.payload.updatedPackages };
            if (state.dimensionUnit === "ft") {
              pLen = ftToCm(updatedPackage.packageLength);
              pWid = ftToCm(updatedPackage.packageWidth);
              pHei = ftToCm(updatedPackage.packageHeight);
            }
            else {
              pLen = updatedPackage.packageLength;
              pWid = updatedPackage.packageWidth;
              pHei = updatedPackage.packageHeight;
            }
            updatedPackage.vWeight =
              (pHei * pWid * pLen) /
              5000;

            return updatedPackage;
          }
          return pkg;
        }),
      };

    case SET_UPLOAD_PROGRESS:
      return {
        ...state,
        uploadProgress: state.uploadProgress.map((progress, index) =>
          index === action.payload.index ? action.payload.progress : progress
        ),
      };

    case RESET_PACKAGE:
      const newPackage = Array.from({ length: 1 }, () => ({
        images: Array(4).fill(null),
        productName: "",
        packageLength: "",
        packageWidth: "",
        packageHeight: "",
        actualWeight: "",
        weight: "",
        vWeight: ""
      }));
      const newUploadProgress = Array(1).fill(0);
      return {
        ...state,
        packages: [...newPackage],
        uploadProgress: [...newUploadProgress],
        packageCount: 1

      }

    case SET_REFERENCE_PACKAGES:
      return {
        ...state,
        referencePackages: action.payload
      }

    case SET_PACKAGE_DIMENSION_UNIT:
      return {
        ...state,
        dimensionUnit: action.payload
      };

    case RESET_PACKAGE_DIMENSIONS:
      return {
        ...state,
        packages: state.packages.map((pkg, index) => {
          if (index === action.payload) {
            return {
              ...pkg,
              packageLength: "",
              packageWidth: "",
              packageHeight: "",
              vWeight: ""
            };
          }
          return pkg;
        }),
      };

    case SET_EDIT_PACKAGE_BTN:
      console.log("SET_EDIT_PACKAGE_BTN action.payload: ", action?.payload);
      return {
        ...state,
        isEditBtnActive:action?.payload
      }
    
    default:
      return state;
  }
};

export default packageReducer;
